import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { setContext } from '@apollo/client/link/context';
import { ApolloLink, createHttpLink } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { sha256 } from 'js-sha256';
// import { sha256 } from 'crypto-hash';
require('cross-fetch/polyfill');
function getLink(options = {}) {
  const {
    uri = process.env.BLAZE_GRAPHQL_URI,
    middleware = [],
    linkOptions = {},
    disableUpload = false,
    enablePersistedQueries = true
  } = options;
  const link = disableUpload ? createHttpLink(_objectSpread({
    uri
  }, linkOptions)) : createUploadLink(_objectSpread({
    uri
  }, linkOptions));
  const preparedMiddleware = middleware.map(middlewareItem => {
    if (typeof middlewareItem === 'function') {
      return setContext(middlewareItem);
    }
    return middlewareItem;
  });
  if (disableUpload && enablePersistedQueries) {
    preparedMiddleware.push(createPersistedQueryLink({
      useGETForHashedQueries: true,
      sha256
      // sha256: query => sha256().update(query).digest('hex')
    }));
  }
  return new ApolloLink.from([...preparedMiddleware, link]); // eslint-disable-line
}
export default getLink;
//# sourceMappingURL=get-link.js.map